import { ENDPOINTS } from '@/settings/endpoints';
import { ChimeraCourseModel } from '@/models/chimera/ChimeraCourseModel';

export const handleLapRedirection = ({
  currentChimeraCourse,
  isMigrationRoute,
}: {
  currentChimeraCourse: ChimeraCourseModel | null;
  isMigrationRoute?: boolean;
}) => {
  if (!currentChimeraCourse || isMigrationRoute) return false;

  if (!currentChimeraCourse.shouldRedirectToClassrooms) {
    window.location.replace(`${ENDPOINTS.lap}/cursos/${currentChimeraCourse.slug}`);
    return true;
  }

  return false;
};
